import Constants from '../../constants'

const getDefaultState = () => {
  return {
    all: [],
    stations: {
      departure: {
        name: Constants.DEFAULT_DEPARTURE_STATION,
        code: Constants.DEFAULT_DEPARTURE_STATION_CODE,
        isStation: true,
        location: {}
      },
      arrival: {
        name: Constants.DEFAULT_ARRIVAL_STATION,
        code: Constants.DEFAULT_ARRIVAL_STATION_CODE,
        isStation: true,
        location: {}
      }
    }
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all,
  getStations: (state) => state.stations,
  getDestination: (state) => (index) => state.all.find(destination => destination.index === index),
  //引き渡すように変更
  getDepatureStation: (state) => state.stations.departure,
  getArrivalStation: (state) => state.stations.arrival
}

const actions = {
  updateDestinations ({ commit }, destinations) {
    commit('setDestinations', destinations)
  },
  buildDestinations ({ commit }, destinations) {
    commit('setBuildDestinations', destinations)
  },
  updateDepartureStationLocation ({ commit }, location) {
    commit('setDepartureStationLocation', location)
  },
  updateArrivalStationLocation ({ commit }, location) {
    commit('setArrivalStationLocation', location)
  },
  updateDepartureStation ({ commit }, name) {
    commit('setDepartureStationName', name)
  },
  updateArrivalStation ({ commit }, name) {
    commit('setArrivalStationName', name)
  },
  updateDepartureStationCode ({ commit }, code) {
    commit('setDepartureStationCode', code)
  },
  updateArrivalStationCode ({ commit }, code) {
    commit('setArrivalStationCode', code)
  },
  updateStations ({ commit }, stations) {
    commit('setStations', stations)
  },
  spliceDestination ({ commit }, params) {
    commit('spliceDestination', params)
  },
  spliceDestinationLock ({ commit }, params) {
    commit('spliceDestinationLock', params)
  },
  deleteDestination ({ commit }, destination) {
    commit('destroyDestination', destination)
  },
  updateVisit ({ commit }, params) {
    commit('setVisit', params)
  },
  updateDatetime ({ commit, dispatch }, params) {
    dispatch('condition/updateTime', params.arrivalTime, { root: true })
    commit('setDatetime', params)
  },
  setStay ({ commit }, params) {
    commit('setStay', params)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setDestinations (state, destinations) {
    state.all = destinations
  },
  setBuildDestinations (state, destinations) {
    const defaultVisit = 60

    state.all = destinations.map((destination, index) => {
      return {
        ...destination,
        index: index,
        type: 'place',
        visit: destination.visit ? destination.visit : defaultVisit
      }
    })
  },
  setDepartureStationLocation (state, location) {
    state.stations.departure.location = location
  },
  setArrivalStationLocation (state, location) {
    state.stations.arrival.location = location
  },
  setDepartureStationName (state, name) {
    state.stations.departure.name = name
  },
  setArrivalStationName (state, name) {
    state.stations.arrival.name = name
  },
  setDepartureStationCode (state, code) {
    state.stations.departure.code = code
  },
  setArrivalStationCode (state, code) {
    state.stations.arrival.code = code
  },
  setStations (state, stations) {
    state.stations = stations
  },
  spliceDestination (state, params) {
    const { route, place, visit } = params

    state.all.splice(route.index, 0, {
      ...place,
      lock: false,
      visit: visit
    })

    state.all = state.all.map((d, index) => {
      return {
        ...d,
        index: index
      }
    })
  },
  spliceDestinationLock (state, params) {
    state.all.forEach(d => d.lock = false)

    const { route, place, visit } = params

    state.all.splice(route.index, 0, {
      ...place,
      lock: true,
      visit: visit
    })

    state.all = state.all.map((d, index) => {
      return {
        ...d,
        index: index
      }
    })
  },
  destroyDestination (state, destination) {
    state.all.splice(destination.index, 1)
    state.all = state.all.map((d, index) => {
      return {
        ...d,
        index: index
      }
    })
  },
  setVisit (state, params) {
    const destination = state.all[params.destination.index]
    destination.visit = params.visit
  },
  setDatetime (state, params) {
    const destination = state.all[params.destination.index]
    state.all.forEach(d => d.lock = false)
    destination.lock = true
  },
  setStay (state, params) {
    const destination = state.all[params.route.index]
    destination.isStay = true
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
